export default {
  slots: {
    identity: {
      label: 'Documento de identificação',
      hint: 'Cartão de cidadão, passaporte ou autorização de residência, frente e verso. As identificações dos seus sócios também vão aqui.',
    },
    trade_registration: {
      label: 'Registo de atividade comercial (Gewerbeanmeldung)',
      hint: 'O registo de atividade comercial recebido da câmara de comércio.',
    },
    commercial_register_extract: {
      label: 'Extrato do registo comercial (Handelsregisterauszug)',
      hint: 'Um extrato atual do registo comercial, se a sua empresa estiver lá registada.',
    },
    bank_statement: {
      label: 'Extrato bancário (Kontoauszug)',
      hint: 'Um extrato recente da sua conta empresarial que mostre o titular da conta e o IBAN.',
    },
    shareholder_list: {
      label: 'Lista de acionistas (Gesellschafterliste)',
      hint: 'A lista atual de acionistas.',
      hint_gbr: 'O seu contrato de sociedade (Gesellschaftsvertrag) ou uma lista de todos os sócios.',
    },
    tax_number: {
      label: 'Número fiscal ou NIF/IVA (Steuernummer oder USt-IdNr.)',
      hint: 'Uma carta das finanças que mostre o seu número fiscal, ou a confirmação do seu NIF/IVA.',
    },
  },
  tags: {
    required: 'Obrigatório',
    optional: 'Opcional',
    missing: 'Em falta',
  },
  kinds: {
    passport: 'Passaporte',
    driver_license: 'Carta de condução',
    id_card: 'Cartão de cidadão',
    residence_permit: 'Autorização de residência',
  },
  holders: {
    owner: 'Proprietário',
    partner: 'Sócio: {{name}}',
  },
  file: {
    with_back: 'Frente e verso',
    uploaded_at: 'Carregado a {{date}}',
    expires_at: 'Válido até {{date}}',
  },
  errors: {
    load: 'Não foi possível carregar os documentos.',
  },
  empty: 'Ainda sem ficheiro',
  buttons: {
    add: 'Adicionar ficheiro',
    replace: 'Substituir',
    remove: 'Remover',
    retry: 'Tentar novamente',
  },
  remove_confirm: {
    title: 'Remover este ficheiro?',
    description: 'Use isto para um ficheiro carregado por engano.',
    ok: 'Remover',
    cancel: 'Cancelar',
  },
  toasts: {
    remove_success: 'Ficheiro removido',
    remove_error: 'Não foi possível remover o ficheiro. Tente novamente.',
  },
};
